import React from 'react';
import { InlineCTA } from './InlineCTA';
export function ProblemSection() {
  const cards = [{
    title: 'Hablar demasiado en plena crisis',
    text: 'Su cerebro en alerta no procesa sermones ni lógica. Solo escucha ruido.'
  }, {
    title: 'Castigar en el peor momento',
    text: 'Aumenta el estrés, la resistencia y rompe la conexión cuando más te necesita.'
  }, {
    title: 'Ignorar esperando que se calme solo',
    text: 'Intensifica su miedo y te hace sentir más sola y frustrada en la situación.'
  }, {
    title: 'Premiar para apagar el incendio',
    text: 'Resuelve el momento rápido, pero no te enseña qué hacer la próxima vez.'
  }];
  return <section className="bg-white py-16 md:py-24 px-5" data-id="element-171">
      <div className="max-w-4xl mx-auto" data-id="element-172">
        <div className="text-center mb-12" data-id="element-173">
          <h2 className="text-2xl md:text-4xl font-bold text-[#4A6741] mb-5" data-id="element-174">
            No es que estés fallando como mamá.
          </h2>
          <p className="text-lg md:text-xl text-[#2D1F0E] font-medium leading-relaxed mb-4" data-id="element-175">
            Es que te enseñaron a corregir conducta cuando en realidad tu hijo
            está en sobrecarga.
          </p>
          <p className="text-[0.95rem] md:text-lg text-[#6B5D4F] leading-relaxed max-w-3xl mx-auto" data-id="element-176">
            Cuando el sistema nervioso entra en alerta, hablar, regañar o
            castigar suele empeorar la crisis. Primero hay que ayudar al cuerpo
            a sentirse seguro. Luego viene el aprendizaje.
          </p>
        </div>

        <div className="bg-[#FDF8F0] rounded-3xl p-6 md:p-10 border border-[#D4A853]/20" data-id="element-177">
          <h3 className="text-xl md:text-2xl font-bold text-[#2D1F0E] text-center mb-8" data-id="element-178">
            Por qué lo que has intentado no funciona:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-179">
            {cards.map((card, idx) => <div key={idx} className="bg-white p-5 rounded-2xl border border-[#4A6741]/10 shadow-sm" data-id="element-180">
                <h4 className="font-bold text-[#C75C3A] mb-2 text-lg" data-id="element-181">
                  {card.title}
                </h4>
                <p className="text-[#6B5D4F] text-[0.9rem] md:text-base leading-relaxed" data-id="element-182">
                  {card.text}
                </p>
              </div>)}
          </div>
        </div>

        <div className="mt-8" data-id="element-183">
          <InlineCTA text="Quiero recuperar la calma" data-id="element-184" />
        </div>
      </div>
    </section>;
}